/*=========================================================================================
  File Name: modulePartenaireGetters.js
  Description: Partenaire Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {}
